export default __webpack_public_path__ + "41aa520855d560093d4d38a209088116.gif";